var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-db3af20c-9368-421b-b1bf-2e46c58354cc",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.77 65.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.05,51.59c2.29,2.3,2.29,6.02,0,8.31l-4.16,4.16c-2.29,2.29-6.02,2.29-8.31,0l-18.7-18.7-18.7,18.7c-2.3,2.29-6.02,2.29-8.31,0l-4.16-4.16c-2.29-2.3-2.29-6.02,0-8.31l18.7-18.7L1.72,14.19C-.57,11.89-.57,8.17,1.72,5.88L5.88,1.72C8.17-.57,11.89-.57,14.19,1.72l18.7,18.7L51.59,1.72c2.3-2.29,6.02-2.29,8.31,0l4.16,4.16c2.29,2.3,2.29,6.02,0,8.31l-18.7,18.7,18.7,18.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkClose);
export default __webpack_public_path__ + "static/media/dark - close.e2813f0fe68dc4478d641802d9360276.svg";
export { ForwardRef as ReactComponent };